import React from 'react';
import { ReportComponent } from '@/pages/reports/schemas';
import { Hero, TodayCarousel, HighlightsCard, NewsCard, BusinessCard, CollapsibleHashtags, CollapsibleCreators, CollapsibleBrands, ThematicSessionCard, CuratorshipCard } from '@/pages/reports/components/ui';
import { TiktokTrendsView } from '@/pages/reports/components/ui/TiktokTrends';
import { useReportI18n } from '@/pages/reports/i18n';

interface RendererProps {
  component: ReportComponent;
}

export const Renderer: React.FC<RendererProps> = ({
  component
}) => {
  const { t } = useReportI18n();
  const renderComponent = () => {
    switch (component.type) {
      case 'hero':
        return <Hero {...(component.props as any)} />;
      case 'today-carousel':
        return <TodayCarousel {...(component.props as any)} />;
      case 'highlights-card':
        return <HighlightsCard {...(component.props as any)} />;
      case 'news-card':
        return <NewsCard {...(component.props as any)} />;
      case 'business-card':
        return <BusinessCard {...(component.props as any)} />;
      case 'tiktok-trends':
        return <TiktokTrendsView {...(component.props as any)} />;
      case 'collapsible-hashtags':
        return <CollapsibleHashtags {...(component.props as any)} />;
      case 'collapsible-creators':
        return <CollapsibleCreators {...(component.props as any)} />;
      case 'collapsible-brands':
        return <CollapsibleBrands {...(component.props as any)} />;
      case 'thematic-session':
        return <ThematicSessionCard {...(component.props as any)} />;
      case 'curatorship':
        return <CuratorshipCard {...(component.props as any)} />;
      default:
        return (
          <div className="container mx-auto px-4 py-8">
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
              {t('renderer.notFound', undefined, { type: component.type })}
            </div>
          </div>
        );
    }
  };

  return <>{renderComponent()}</>;
};
